import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
export default {
    baseurl:'/api/swyl/v1',
    //合同列表查询
    page(query){
        return http({
            url: this.baseurl+'/hetong/bscContract/selectPage',
            method: 'post',
            params: query
        });
    },
    contractyxListPage(query){
        return http({
            url: '/api/swyl/v1/product/contractyxListPage',
            method: 'post',
            params: query
        });
    },
    //合同详情查询
    detail(query){
        return http({
            url: this.baseurl+'/hetong/bscContract/selectById?id='+query,
            method: 'post',
            params: query
        });
    },
    //合同详情查询
    selectByIdAgent(query){
        return http({
            url: this.baseurl+'/hetong/bscContract/selectByIdAgent?id='+query,
            method: 'post',
            params: query
        });
    },
    //合同详情审批页查询
    detailS(query){
        return http({
            url: this.baseurl+'/hetong/bscContract/selectByIdShenpi?id='+query,
            method: 'post',
            params: query
        });
    },
    //解除/冻结合同
    doFreeze(query){
        return http({
            url: this.baseurl+'/hetong/bscContractPayment/freeze',
            method: 'post',
            params: query
        });
    },
	//获取LEG合同信息
	getLEG(query){
		return http({
			url: this.baseurl+"/hetong/bscContract/getLEGContractInfo",
			method: 'post',
			params: query
		})
	},
    getContractCode(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/getContractCode",
            method: 'post',
            params: query
        })
    },
	//合同提交
	insert(query){
		// return http({
		// 	url: this.baseurl+"/hetong/bscContract/insert",
		// 	method: 'post',
		// 	params: query
		// })
		return http.post(this.baseurl+"/hetong/bscContract/insert",query);
	},
    //合同提交调整
    insertS(query){
        return http.post(this.baseurl+"/hetong/bscContract/insertShenpi",query);
    },
    //合同审批
    updateShenpi(query){
        return http.post(this.baseurl+"/hetong/bscContract/updateShenpi",query);
    },
    //合同审批
    updateShenpiHhcg(query){
        return http.post(this.baseurl+"/hetong/bscContract/updateShenpiHhcg",query);
    },
    //合同审批
    getHhxmContract(usercode){
        return http.post(this.baseurl+"/hetong/bscContract/getHhxmContract?usercode="+usercode);
    },
	//获取客户
	getCustomerList(query){
		return http({
			url: this.baseurl+"/basic/bscUserInfo/selectList",
			method: 'post',
			params: query
		})
	},
	//根据采购项目ID查询供应商信息
	getFinalSuppliers(query){
		return http({
			url: this.baseurl+"/xiangmu/proPriceInquiry/getFinalSuppliers",
			method: 'post',
			params: query
		})
	},
	//查询供应商中标产品信息
	getProductInfoBySupplier(query){
		return http({
			url: this.baseurl+"/xiangmu/proPriceInquiry/getProductInfoBySupplier",
			method: 'post',
			params: query
		})
	},
    getOneViewAgentListByUsercode(query){
        return http({
            url: "/api/swyl/v1/viewagentlist/viewAgentList/getOneViewAgentListByUsercode?usercodeInfo=" + query,
            method: 'post',
        })
    },
    //采购合同冻结
    freezeWindowCGDJ(v){
        return http.post("/api/swyl/v1/hetong/bscContract/freezeWindowCGDJ?id="+v);
    },
    //采购合同解冻
    freezeWindowCGJD(v){
        return http.post("/api/swyl/v1/hetong/bscContract/freezeWindowCGJD?id="+v);
    },

    //查找采购合同产品
    findCGProduct(v){
        return http.post("/api/swyl/v1/hetong/bscContract/findCGProduct?id="+v);
    },

    // 修改  提交日期及采购经理审批
    bscContractEdit(data){
        return http({
            url: this.baseurl+"/hetong/bscContract/edit",
            method: 'post',
            data: data
        })
    },


    // 审批 提交日期及采购经理审批
    shenpiEdit(data){
        return http({
            url: this.baseurl+"/hetong/bscContract/shenpiEdit",
            method: 'post',
            data: data
        })
    },

    // 审批 提交日期及采购经理审批
    selectEditById(query){
        return http({
            url: this.baseurl+"/hetong/bscContract/selectEditById",
            method: 'post',
            params: query
        })
    },

    selectRentTimeByType(query){
        return http({
            url: "/api/swyl/v1/hetong/bscContractRentPrice/selectRentTimeByType",
            method: 'post',
            params: query
        })
    },
    // 获取型号?prodcode=
    selectByCode(query){
        return http({
            url: "/api/swyl/v1/xiaoshouallwuliao/viewXiaoshouyangbiaoAllwuliao/selectByCode",
            method: 'post',
            params: query
        })
    },

    //根据费用类型获取价格
    selectByRentType(query){
        return http({
            url: "/api/swyl/v1/hetong/bscContractRentPrice/selectByType",
            method: 'post',
            params: query
        })
    },
//经销商框架合同
    insertAgent(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/insertAgent",
            method: 'post',
            data: query
        })
    },
    //经销商框架合同
    insertAgentNew(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/insertAgentNew",
            method: 'post',
            data: query
        })
    },

    //经销商框架合同
    updateAgentNew(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/updateAgentNew",
            method: 'post',
            data: query
        })
    },
    //经销商框架合同
    insertHhxm(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/insertHhxm",
            method: 'post',
            data: query
        })
    },

    insertAgentFb(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/insertAgentFb",
            method: 'post',
            data: query
        })
    },

    contractFbPass(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/contractFbPass",
            method: 'post',
            data: query
        })
    },

    //根据instid查询合同
    getContractByInstid(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/getContractByInstid?instid="+query,
            method: 'post',
        })
    },
    //根据instid查询合同
    getContractAddByInstid(query) {
        return http({
            url: "/api/swyl/v1/demo/bscContractAgentAdd/getContractAddByInstid?instid="+query,
            method: 'post',
        })
    },
    //根据instid查询合同
    getContractByUsercode(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/getContractByUsercode?usercode="+query,
            method: 'post',
        })
    },
    //查询有没有有效的合同
    getDlsContract(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/getDlsContract",
            method: 'post',
            data: query
        })
    },

    //经销商框架合同审批完成
    contractPass(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/contractPass",
            method: 'post',
            data: query
        })
    },

    //经销商框架合同大区经理通过
    daquPass(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/daquPass",
            method: 'post',
            params: query
        })
    },

    //合同列表查询经销商
    pageByAgent(query){
        return http({
            url: this.baseurl+'/hetong/bscContract/selectAgentPage',
            method: 'post',
            params: query
        });
    },
    //获取采购项目
    selectCgProList(query){
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/selectCgProjectList',
            method: 'post',
            params: query
        });
    },

    //获取采购项目
    dlsCancel(query){
        return http({
            url: '/api/swyl/v1/hetong/bscContract/dlsCancel?id='+query,
            method: 'post',
        });
    },

    //获取当前登录人公司
    getUserCompany(query){
        return http({
            url: '/api/swyl/v1/hetong/bscContract/getUserCompany',
            method: 'post',
            params:query,
        });
    },

    //获取采购项目
    getOemProducts(query){
        return http({
            url: '/api/swyl/v1/hetong/bscContract/getOemProducts?materialCode='+query,
            method: 'post',
        });
    },

    //根据instid查询合同
    getContractSon(query) {
        return http({
            url: this.baseurl+"/hetong/bscContract/getContractSon?id="+query,
            method: 'post',
        })
    },
    //经销商框架合同协议
    insertAgentAdd(query) {
        return http({
            url: "/api/swyl/v1/demo/bscContractAgentAdd/insertAgentAdd",
            method: 'post',
            data: query
        })
    },

    //经销商框架合同审批完成
    contractPassAdd(query) {
        return http({
            url: "/api/swyl/v1/demo/bscContractAgentAdd/contractPassAdd",
            method: 'post',
            data: query
        })
    },
    //经销商框架合同审批完成
    contractAgentAddFxListPage(query) {
        return http({
            url: "/api/swyl/v1/hetong/bscContract/contractAgentAddFxListPage",
            method: 'post',
            data: query
        })
    },
    //经销商框架合同审批完成
    hhContractPass(query) {
        return http({
            url: "/api/swyl/v1/hetong/bscContract/hhContractPass",
            method: 'post',
            data: query
        })
    },
    //合同详情审批页查询
    selectByInstidShenpi(query){
        return http({
            url: this.baseurl+'/hetong/bscContract/selectByInstidShenpi?instid='+query,
            method: 'post',
            params: query
        });
    },

    //合同详情审批页查询
    selectByCodeHhxm(query){
        return http({
            url: '/api/swyl/v1/demo/bscContractHhxm/selectByCode',
            method: 'post',
            params: query
        });
    },



}
